import React, { ComponentProps, ReactElement, cloneElement } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { AnimatedCheckmark } from 'components/Icon/AnimatedCheckmark';
import CmsSubscribeContainer from 'containers/CmsSubscribeContainer';
import { CmsApiSubscribeLink } from 'modules/cms/api/types/CmsApiLink';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  buttonData: CmsApiSubscribeLink;
  eventProperties: Record<string, unknown>;
  children: ReactElement<ComponentProps<typeof AnchorButton>>;
  blockId: string;
  sectionIndex: number;
};

export function CmsSubscribeButton(props: Props) {
  const { sectionIndex, blockId, buttonData, children, eventProperties } =
    props;

  return (
    <CmsSubscribeContainer
      blockId={blockId}
      index={sectionIndex}
      redirectUrl={buttonData.data.redirectUrl}
      render={({ subscribe, isSubscribed }) =>
        cloneElement(
          children,
          {
            onClick: () => {
              subscribe();
              trackClicked('CMS Block', {
                redirect_url: buttonData.data.redirectUrl,
                ...eventProperties,
              });
            },
            disabled: isSubscribed,
            'data-qa-id': 'cms-subscribe-button-link',
          },
          isSubscribed ? (
            <Box display="flex" mr="8px">
              <AnimatedCheckmark size={24} colorName="white" />
              {getText('Subscribed')}
            </Box>
          ) : (
            buttonData.text
          ),
        )
      }
    />
  );
}
